export default "__VITE_ASSET__DfIG8Mzg__"